const aboutData = [
    {
        id: "1",
        image: require("../../assets/icons/1.svg").default,
        title: "Proper Packing Techniques",
        description: "We use the right-sized boxes for every item, ensuring maximum protection."
    },
    {
        id: "2",
        image: require("../../assets/icons/2.svg").default,
        title: "Room-by-Room Organization",
        description: " We pack belongings systematically, avoiding mixing items from different rooms to make unpacking easier."
    },
    {
        id: "3",
        image: require("../../assets/icons/3.svg").default,
        title: "Weight Distribution Excellence",
        description: "Heavy items are placed at the bottom of boxes, while lighter items go on top to prevent damage."
    },
    {
        id: "4",
        image: require("../../assets/icons/4.svg").default,
        title: "Secure & Durable Packing",
        description: "We use strong, high-quality tape and reinforcement techniques to keep boxes secure."
    },
    {
        id: "5",
        image: require("../../assets/icons/5.svg").default,
        title: "Space Optimization",
        description: "We ensure boxes are properly filled to prevent shifting and potential damage during transit."
    },
    {
        id: "6",
        image: require("../../assets/icons/6.svg").default,
        title: "Specialized Kitchen Packing",
        description: "Fragile kitchenware is given extra protection with specialized packing methods to prevent breakage."
    },
]

export default aboutData;